<template>
<div class="UpdateChallengeDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Perc margin-top-1Perc cursor-pointer" v-on:click="updateEditChallengeOverlay($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                 <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-right-0Perc text-align-right">
                  Title
                 </div>
                 <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="TitleValue">
                        </div>
                    </div>
                 </div>
                 <div class="col-md-6 col-lg-6"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Description
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <textarea class="form-control" rows="5" v-model="DescValue"/>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-Left-0px padding-right-0Px">
                  Context
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0px padding-right-0px">
                        <tinymce id="d1" v-model="ContextValue"></tinymce>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <!-- <div class="col-md-1 col-lg-1"></div> -->
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  T L Q(s)
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <textarea class="form-control" rows="5" v-model="TLQValue"/>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Rating Question
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="RatingQueValue">
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Feedback Question
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="FeedbackQueValue">
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Challenge Video
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                          <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                          <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValue"></video-quality-control>
                          <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Challenge Caption File
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="row">
                    <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                        <div class="col-sm-12">
                          <input type="file" id="challengeVttFile" accept=".vtt">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-12 text-align-left padding-left-22px" v-if="selectedChallengeObj.ChallengeVideoCaptionsUrl !== null && selectedChallengeObj.ChallengeVideoCaptionsUrl !== '' && selectedChallengeObj.ChallengeVideoCaptionsUrl !== 'null' && selectedChallengeObj.ChallengeVideoCaptionsUrl !== undefined">
                      <div class="form-group">
                        <div class="col-sm-12">
                          <a :href="ChallengeVTTFileUrlValue">Download Existing</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <hr width="90%">
              <!-- PS: Faculty Vido is startting from here -->
              <div class="row vertical-align">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                   Faculty Response Video
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                          <video-quality-control :parentElementObj="videoUrlObjForFaculty" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableFVInputBoxFor360And720" @updatedValue="updateVideoQualityValueForFacultyVideos"></video-quality-control>
                          <video-quality-control :parentElementObj="videoUrlObjForFaculty" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValueForFacultyVideos"></video-quality-control>
                          <video-quality-control :parentElementObj="videoUrlObjForFaculty" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableFVInputBoxFor360And720" @updatedValue="updateVideoQualityValueForFacultyVideos"></video-quality-control>
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Faculty Caption File
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="row">
                    <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                        <div class="col-sm-12">
                           <input type="file" id="facultyVttFile" accept=".vtt">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-12 text-align-left padding-left-22px" v-if="selectedChallengeObj.FacultyResponseCaptionsUrl !== null && selectedChallengeObj.FacultyResponseCaptionsUrl !== '' && selectedChallengeObj.FacultyResponseCaptionsUrl !== 'null' && selectedChallengeObj.FacultyResponseCaptionsUrl !== undefined">
                      <div class="form-group">
                        <div class="col-sm-12">
                          <a :href="FacultyVTTFileUrlValue">Download Existing</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <hr width="90%">
              <!-- VTT file end -->
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Topic
                </div>
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12">
                        <select class="form-control Padding-right-0px" v-model="getSelectedTopicId">
                          <option value=-1 disabled>Select</option>
                          <option v-for="topicObj in getTopicList" v-bind:key="topicObj.TopicId" v-bind:value="topicObj.TopicId">{{ topicObj.TopicName }}</option>
                        </select>
                      </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-left-0px padding-right-0Px">
                  Silhoutee2 Name
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="Silhoutee2NameValue">
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Designation1
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="Designation1Value">
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-left-0px padding-right-0Px">
                  Designation2
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="Designation2Value">
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc vertical-align">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px padding-left-0px">
                  Silhoutee2 Image
                </div>
                <div class="col-md-4 col-lg-4">
                  <img :src="Silhoutee2ImageUrlValue" class="silhoutee-img-width-height" id="silhouteeImg" @error="assignDefaultImage"/>
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="file" id='silhoutee2Img'>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-4 col-lg-4">
                </div>  
                <div class="col-md-offset-1 col-md-4 col-lg-offset-1 col-lg-3">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateChallenge">Update Challenge</button>
                </div>  
                <div class="col-md-4 col-lg-4">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 </div>
</template>

<script>
import { topicService } from '@/server-util/topic-service'
import { constants } from '@/utils/constants'
import server from '@/utils/server'
import ErrorImage from '../assets/images/imagenotfound.svg'
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { challengeService } from '@/server-util/challenge-service'
import tinymce from 'vue-tinymce-editor'
import VideoQualityControl from '@/components/VideoQualityControl'
export default {
  props: ['selectedChallengeObj'],
  created: function () {
    this.setDefaultValues()
    this.getTopics()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      disableInputBoxFor360And720: true,
      disableFVInputBoxFor360And720: true,
      videoUrlObj: {
        LowQualityVideoUrl: '',
        HDVideoUrl: '',
        VideoUrl: ''
      },
      videoUrlObjForFaculty: {
        LowQualityVideoUrl: '',
        HDVideoUrl: '',
        VideoUrl: ''
      },
      challengeObj: {
        ChallengeId: '',
        Title: '',
        Desc: '',
        Context: '',
        VideoUrl: '',
        ChallengeVideoHDUrl: '',
        ChallengeVideoLQUrl: '',
        FacultyResponseVideoLQUrl: '',
        FacultyVideoUrl: '',
        FacultyResponseVideoHDUrl: '',
        TrafficLightQuestions: '',
        RatingQuestion: '',
        TextFeedbackQuestion: '',
        Silhoutee1Name: '',
        Silhoutee2Name: '',
        Silhoutee2Image: '',
        Designation1: '',
        Designation2: '',
        TopicId: -1,
        ChallengeVideoCaptionsUrl: null,
        FacultyResponseCaptionsUrl: null
      }
    }
  },
  name: 'UpdateChallengeOverlay',
  methods: {
    updateVideoQualityValue (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.LowVideoURLValue = videoUrl
          this.ChallengeResponseLQVideoUrlValue = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.VideoURLValue = videoUrl
          this.ChallengeResponseVideoUrlValue = videoUrl
          if (this.ChallengeResponseVideoUrlValue.trim().length === 0) {
            this.LowVideoURLValue = ''
            this.ChallengeResponseLQVideoUrlValue = ''
            this.HDVideoURLValue = ''
            this.ChallengeResponseHDVideoUrlValue = ''
            this.disableInputBoxFor360And720 = true
          } else {
            this.disableInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.HDVideoURLValue = videoUrl
          this.ChallengeResponseHDVideoUrlValue = videoUrl
          break
      }
    },
    updateVideoQualityValueForFacultyVideos (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.FVLowVideoURLValue = videoUrl
          this.FacultyResponseLQVideoUrlValue = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.FVVideoURLValue = videoUrl
          this.FacultyResponseVideoUrlValue = videoUrl
          if (this.FacultyResponseVideoUrlValue.trim().length === 0) {
            this.FVLowVideoURLValue = ''
            this.FacultyResponseLQVideoUrlValue = ''
            this.FVHDVideoURLValue = ''
            this.FacultyResponseHDVideoUrlValue = ''
            this.disableFVInputBoxFor360And720 = true
          } else {
            this.disableFVInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.FVHDVideoURLValue = videoUrl
          this.FacultyResponseHDVideoUrlValue = videoUrl
          break
      }
    },
    setDefaultValues: function () {
      console.log('Object:' + this.selectedChallengeObj.Context)
      this.challengeObj.ChallengeId = this.selectedChallengeObj.ChallengeId
      this.challengeObj.Title = this.selectedChallengeObj.Title
      this.challengeObj.Desc = this.selectedChallengeObj.Desc
      this.challengeObj.TrafficLightQuestions = this.selectedChallengeObj.TrafficLightQuestions
      this.challengeObj.RatingQuestion = this.selectedChallengeObj.RatingQuestion
      this.challengeObj.TextFeedbackQuestion = this.selectedChallengeObj.TextFeedbackQuestion
      this.challengeObj.VideoUrl = (this.selectedChallengeObj.VideoUrl !== null && this.selectedChallengeObj.VideoUrl !== 'null' && this.selectedChallengeObj.VideoUrl !== undefined && this.selectedChallengeObj.VideoUrl !== 'undefined' && this.selectedChallengeObj.VideoUrl !== '') ? this.selectedChallengeObj.VideoUrl : ''
      this.videoUrlObj.VideoUrl = this.challengeObj.VideoUrl
      this.disableInputBoxFor360And720 = this.challengeObj.VideoUrl.trim().length === 0
      this.challengeObj.ChallengeVideoHDUrl = (this.selectedChallengeObj.ChallengeVideoHDUrl !== null && this.selectedChallengeObj.ChallengeVideoHDUrl !== 'null' && this.selectedChallengeObj.ChallengeVideoHDUrl !== undefined && this.selectedChallengeObj.ChallengeVideoHDUrl !== 'undefined' && this.selectedChallengeObj.ChallengeVideoHDUrl !== '') ? this.selectedChallengeObj.ChallengeVideoHDUrl : ''
      this.videoUrlObj.HDVideoUrl = this.challengeObj.ChallengeVideoHDUrl
      this.challengeObj.ChallengeVideoLQUrl = (this.selectedChallengeObj.ChallengeVideoLQUrl !== null && this.selectedChallengeObj.ChallengeVideoLQUrl !== 'null' && this.selectedChallengeObj.ChallengeVideoLQUrl !== undefined && this.selectedChallengeObj.ChallengeVideoLQUrl !== 'undefined' && this.selectedChallengeObj.ChallengeVideoLQUrl !== '') ? this.selectedChallengeObj.ChallengeVideoLQUrl : ''
      this.videoUrlObj.LowQualityVideoUrl = this.challengeObj.ChallengeVideoLQUrl
      this.challengeObj.FacultyVideoUrl = (this.selectedChallengeObj.FacultyVideoUrl !== null && this.selectedChallengeObj.FacultyVideoUrl !== 'null' && this.selectedChallengeObj.FacultyVideoUrl !== undefined && this.selectedChallengeObj.FacultyVideoUrl !== 'undefined' && this.selectedChallengeObj.FacultyVideoUrl !== '') ? this.selectedChallengeObj.FacultyVideoUrl : ''
      this.videoUrlObjForFaculty.VideoUrl = this.challengeObj.FacultyVideoUrl
      this.disableFVInputBoxFor360And720 = this.videoUrlObjForFaculty.VideoUrl.trim().length === 0
      this.challengeObj.FacultyResponseVideoHDUrl = (this.selectedChallengeObj.FacultyResponseVideoHDUrl !== null && this.selectedChallengeObj.FacultyResponseVideoHDUrl !== 'null' && this.selectedChallengeObj.FacultyResponseVideoHDUrl !== undefined && this.selectedChallengeObj.FacultyResponseVideoHDUrl !== 'undefined' && this.selectedChallengeObj.FacultyResponseVideoHDUrl !== '') ? this.selectedChallengeObj.FacultyResponseVideoHDUrl : ''
      this.videoUrlObjForFaculty.HDVideoUrl = this.challengeObj.FacultyResponseVideoHDUrl
      this.challengeObj.FacultyResponseVideoLQUrl = (this.selectedChallengeObj.FacultyResponseVideoLQUrl !== null && this.selectedChallengeObj.FacultyResponseVideoLQUrl !== 'null' && this.selectedChallengeObj.FacultyResponseVideoLQUrl !== undefined && this.selectedChallengeObj.FacultyResponseVideoLQUrl !== 'undefined' && this.selectedChallengeObj.FacultyResponseVideoLQUrl !== '') ? this.selectedChallengeObj.FacultyResponseVideoLQUrl : ''
      this.videoUrlObjForFaculty.LowQualityVideoUrl = this.challengeObj.FacultyResponseVideoLQUrl
      this.challengeObj.ChallengeVideoCaptionsUrl = this.selectedChallengeObj.ChallengeVideoCaptionsUrl
      this.challengeObj.FacultyResponseCaptionsUrl = this.selectedChallengeObj.FacultyResponseCaptionsUrl
      this.challengeObj.Silhoutee1Name = this.selectedChallengeObj.Silhoutee1Name
      this.challengeObj.Designation1 = this.selectedChallengeObj.Designation1
      this.challengeObj.Silhoutee2Name = this.selectedChallengeObj.Silhoutee2Name
      this.challengeObj.Designation2 = this.selectedChallengeObj.Designation2
      this.challengeObj.TopicId = this.selectedChallengeObj.TopicId !== undefined && this.selectedChallengeObj.TopicId !== null ? this.selectedChallengeObj.TopicId : -1
      setTimeout(() => {
        this.challengeObj.Context = dmAdminUtils.updateUrls(this.selectedChallengeObj.Context)
      }, 500)
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    updateEditChallengeOverlay: function (event, flagToUpdate) {
      console.log(JSON.stringify(this.selectedChallengeObj))
      this.$emit('closeUpdateOverlay', flagToUpdate)
    },
    chekcSilhouteeFileExtesion: function (fileName) {
      var exts = ['.png', '.jpeg', '.jpg']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    getTopics: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== '' &&
        storeObj.state.access_token !== null
      ) {
        if (storeObj.state.topicList.length === 0) {
          // AK: Start showing spinner only if topic list not found
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }

        topicService.getAllTopics(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.topicList = responseObj.data
              // AK: Hide Spinner if its showing to user
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              // console.log(JSON.stringify(storeObj.state.topicList))
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner if its showing to user
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET TOPIC LIST OPERATION'
        )
      }
    },
    updateChallenge: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var fileUrl = document.getElementById('silhoutee2Img').files[0]
        if (fileUrl !== undefined) {
          if (
            !this.chekcSilhouteeFileExtesion(
              document.getElementById('silhoutee2Img').value
            )
          ) {
            this.showAlertDialog = true
            this.errorMsg = 'Invalid file format detected.'
            return
          }
        }
        var challengeVttFileUrl = document.getElementById('challengeVttFile').files[0]
        if (challengeVttFileUrl === undefined && challengeVttFileUrl === null) {
          challengeVttFileUrl = null
        }
        var facultyVttFileUrl = document.getElementById('facultyVttFile').files[0]
        if (facultyVttFileUrl === undefined && facultyVttFileUrl === null) {
          facultyVttFileUrl = null
        }
        const formData = new FormData()
        formData.append('ChallengeId', this.challengeObj.ChallengeId)
        formData.append('Title', this.challengeObj.Title)
        formData.append('Desc', this.challengeObj.Desc)
        if (this.challengeObj.Context !== undefined && this.challengeObj.Context !== 'undefined' && this.challengeObj.Context !== null && this.challengeObj.Context !== 'null' && this.stripHtml(this.challengeObj.Context).length > 0) {
          formData.append('Context', this.challengeObj.Context)
        } else {
          formData.append('Context', null)
        }
        formData.append('TrafficLightQuestions', this.challengeObj.TrafficLightQuestions)
        formData.append('RatingQuestion', this.challengeObj.RatingQuestion)
        formData.append('TextFeedbackQuestion', this.challengeObj.TextFeedbackQuestion)
        const videoUrl = this.challengeObj.VideoUrl !== '' ? this.challengeObj.VideoUrl.trim() : ''
        formData.append('VideoUrl', videoUrl)
        const hdVideoUrl = this.challengeObj.ChallengeVideoHDUrl !== '' ? this.challengeObj.ChallengeVideoHDUrl.trim() : ''
        formData.append('ChallengeVideoHDUrl', hdVideoUrl)
        const lowVideoUrl = this.challengeObj.ChallengeVideoLQUrl !== '' ? this.challengeObj.ChallengeVideoLQUrl.trim() : ''
        formData.append('ChallengeVideoLQUrl', lowVideoUrl)
        const facultyVideoUrl = this.challengeObj.FacultyVideoUrl !== '' ? this.challengeObj.FacultyVideoUrl.trim() : ''
        formData.append('FacultyVideoUrl', facultyVideoUrl)
        const facultyHdVideoUrl = this.challengeObj.FacultyResponseVideoHDUrl !== '' ? this.challengeObj.FacultyResponseVideoHDUrl.trim() : ''
        formData.append('FacultyResponseVideoHDUrl', facultyHdVideoUrl)
        const facultyLowVideoUrl = this.challengeObj.FacultyResponseVideoLQUrl !== '' ? this.challengeObj.FacultyResponseVideoLQUrl.trim() : ''
        formData.append('FacultyResponseVideoLQUrl', facultyLowVideoUrl)
        formData.append('Silhoutee1Name', this.challengeObj.Silhoutee1Name)
        formData.append('Silhoutee2Name', this.challengeObj.Silhoutee2Name)
        formData.append('Designation1', this.challengeObj.Designation1)
        formData.append('Designation2', this.challengeObj.Designation2)
        formData.append('Silhoutee2ImageFile', fileUrl)
        formData.append('TopicId', this.challengeObj.TopicId)
        formData.append('ChallengeVideoVttFileInput', challengeVttFileUrl)
        formData.append('facultyVideoVttFileInput', facultyVttFileUrl)
        var storeObj = this.$store
        if (
          storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
        ) {
          // AK: Start showing Spinner (AllChallengeDetailList file)
          this.$emit('showSpinner', true)
          challengeService
            .updateChallenge(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Challenge List again (AllChallengeDetailList file)
                this.$emit('refreshList', true)
                // AK: Hide showing Spinner (AllChallengeDetailList file)
                this.$emit('showSpinner', false)
                // AK: Hide Update Challenge Overlay (AllChallengeDetailList file)
                this.$emit('closeUpdateOverlay', false)
              } else {
                // AK: Hide Spinner (AllChallengeDetailList file)
                this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner (AllChallengeDetailList file)
              this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined Update Challenge'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    assignDefaultImage: function (event) {
      document.getElementById('silhouteeImg').src = ErrorImage
    },
    validateRequiredFieldBeforeSubmit: function () {
      var challengeVttFileUrl = document.getElementById('challengeVttFile').files[0]
      var facultyVttFileUrl = document.getElementById('facultyVttFile').files[0]
      if (this.TitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        this.challengeObj.Title = this.selectedChallengeObj.Title
        return false
      } else if (this.DescValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Description can\'t be empty.'
        this.challengeObj.Desc = this.selectedChallengeObj.Desc
        return false
      } else if (this.TLQValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Traffic light question(s) can\'t be empty.'
        this.challengeObj.TrafficLightQuestions = this.selectedChallengeObj.TrafficLightQuestions
        return false
      } else if (this.challengeObj.RatingQuestion !== null && this.challengeObj.RatingQuestion !== undefined && this.challengeObj.RatingQuestion.length > 0 && (!this.challengeObj.RatingQuestion.replace(/\s/g, '').length)) {
        this.showAlertDialog = true
        this.errorMsg = 'Rating question can\'t only have empty spaces.'
        return false
      } else if (this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Video url.'
        return false
      } else if (this.VideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Video url.'
        return false
      } else if (this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Video url.'
        return false
      } else if (this.FVLowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.FVLowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.FVLowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Faculty Video url.'
        return false
      } else if (this.FVVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.FVVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.FVVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Faculty Video url.'
        return false
      } else if (this.FVHDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.FVHDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.FVHDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Faculty Video url.'
        return false
      } else if (this.challengeObj.TopicId === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select topic.'
        return false
      } else if (this.Silhoutee2NameValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Silhoutee2 name can\'t be empty.'
        this.challengeObj.Silhoutee2Name = this.selectedChallengeObj.Silhoutee2Name
        return false
      } else if (challengeVttFileUrl !== undefined && challengeVttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('challengeVttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for challenge video caption file.'
        return false
      } else if (facultyVttFileUrl !== undefined && facultyVttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('facultyVttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for faculty Response video caption file.'
        return false
      }
      return true
    },
    checkVttFileExtesion: function (fileName) {
      var exts = ['.vtt']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    }
  },
  components: {
    'alert-box': AlertBox,
    'tinymce': tinymce,
    'video-quality-control': VideoQualityControl
  },
  computed: {
    TitleValue: {
      get: function () {
        return this.challengeObj.Title
      },
      set: function (newValue) {
        this.challengeObj.Title = newValue
      }
    },
    DescValue: {
      get: function () {
        return this.challengeObj.Desc
      },
      set: function (newValue) {
        this.challengeObj.Desc = newValue
      }
    },
    ContextValue: {
      get: function () {
        return this.challengeObj.Context
      },
      set: function (newValue) {
        this.challengeObj.Context = newValue
      }
    },
    TLQValue: {
      get: function () {
        return this.challengeObj.TrafficLightQuestions
      },
      set: function (newValue) {
        this.challengeObj.TrafficLightQuestions = newValue
      }
    },
    RatingQueValue: {
      get: function () {
        return this.challengeObj.RatingQuestion
      },
      set: function (newValue) {
        this.challengeObj.RatingQuestion = newValue
      }
    },
    FeedbackQueValue: {
      get: function () {
        return this.challengeObj.TextFeedbackQuestion
      },
      set: function (newValue) {
        this.challengeObj.TextFeedbackQuestion = newValue
      }
    },
    Silhoutee1NameValue: {
      get: function () {
        return this.challengeObj.Silhoutee1Name
      },
      set: function (newValue) {
        this.challengeObj.Silhoutee1Name = newValue
      }
    },
    Designation1Value: {
      get: function () {
        return this.challengeObj.Designation1
      },
      set: function (newValue) {
        this.challengeObj.Designation1 = newValue
      }
    },
    Silhoutee2NameValue: {
      get: function () {
        return this.challengeObj.Silhoutee2Name
      },
      set: function (newValue) {
        this.challengeObj.Silhoutee2Name = newValue
      }
    },
    Designation2Value: {
      get: function () {
        return this.challengeObj.Designation2
      },
      set: function (newValue) {
        this.challengeObj.Designation2 = newValue
      }
    },
    Silhoutee2ImageUrlValue: {
      get: function () {
        return server.baseURL() + '/api/Challenge/Silhoutee2Image?challengeId=' + this.selectedChallengeObj.ChallengeId
      }
    },
    getSelectedTopicId: {
      get: function () {
        return this.challengeObj.TopicId
      },
      set: function (newValue) {
        this.challengeObj.TopicId = newValue
      }
    },
    getTopicList: {
      get: function () {
        return this.$store.state.topicList
      }
    },
    ChallengeVTTFileUrlValue: {
      get: function () {
        return this.challengeObj.ChallengeVideoCaptionsUrl
      }
    },
    FacultyVTTFileUrlValue: {
      get: function () {
        return this.challengeObj.FacultyResponseCaptionsUrl
      }
    },
    VideoURLValue: {
      get: function () {
        return this.videoUrlObj.VideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.VideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.videoUrlObj.HDVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.HDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.videoUrlObj.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.LowQualityVideoUrl = newValue
      }
    },
    FVVideoURLValue: {
      get: function () {
        return this.videoUrlObjForFaculty.VideoUrl
      },
      set: function (newValue) {
        this.videoUrlObjForFaculty.VideoUrl = newValue
      }
    },
    FVHDVideoURLValue: {
      get: function () {
        return this.videoUrlObjForFaculty.HDVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObjForFaculty.HDVideoUrl = newValue
      }
    },
    FVLowVideoURLValue: {
      get: function () {
        return this.videoUrlObjForFaculty.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObjForFaculty.LowQualityVideoUrl = newValue
      }
    },
    FacultyResponseVideoUrlValue: {
      get: function () {
        return this.challengeObj.FacultyVideoUrl
      },
      set: function (newValue) {
        this.challengeObj.FacultyVideoUrl = newValue
      }
    },
    FacultyResponseLQVideoUrlValue: {
      get: function () {
        return this.challengeObj.FacultyResponseVideoLQUrl
      },
      set: function (newValue) {
        this.challengeObj.FacultyResponseVideoLQUrl = newValue
      }
    },
    FacultyResponseHDVideoUrlValue: {
      get: function () {
        return this.challengeObj.FacultyResponseVideoHDUrl
      },
      set: function (newValue) {
        this.challengeObj.FacultyResponseVideoHDUrl = newValue
      }
    },
    ChallengeResponseVideoUrlValue: {
      get: function () {
        return this.challengeObj.VideoUrl
      },
      set: function (newValue) {
        this.challengeObj.VideoUrl = newValue
      }
    },
    ChallengeResponseLQVideoUrlValue: {
      get: function () {
        return this.challengeObj.ChallengeVideoLQUrl
      },
      set: function (newValue) {
        this.challengeObj.ChallengeVideoLQUrl = newValue
      }
    },
    ChallengeResponseHDVideoUrlValue: {
      get: function () {
        return this.challengeObj.ChallengeVideoHDUrl
      },
      set: function (newValue) {
        this.challengeObj.ChallengeVideoHDUrl = newValue
      }
    }
  }
}
</script>

<style scoped>
.silhoutee-img-width-height {
  width: 90%;
  height: 80%;
  margin: 0 auto !important;
}
.response-video-not-available {
  color: red;
  text-align: center;
}
.red{
  background-color: red;
}
.red-border {
  border: 1px solid red !important;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2% !important;
}
.margin-bottom-1Perc
{
	margin-bottom: 1%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 16px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.padding-Left-7px{
  padding-left:7px; 
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.padding-right-0Perc{
  padding-right:0%;
}
.blueColor {
  color: #337ab7;
}
.margin-right-15px {
  margin-right: 15px;
}
.text-align-center {
  text-align: center;
}
.opacity0Point5 {
  opacity: 0.5;
}
.orangeColor {
  color: #f39c12;
}
.padding-right-0px {
  padding-right: 0px;
}
</style>





// WEBPACK FOOTER //
// src/components/UpdateChallengeOverlay.vue